module.exports = __webpack_public_path__ + "static/media/TableLeg_After.3f9d7d4f.jpg";